import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { Divider } from 'sdk'
import { Content } from 'sdk/components'
import { FlagshipProduct } from 'sdk/sections/flagship-product/FlagshipProduct'
import { PartnerProducts } from 'sdk/sections'
import { SDKDownloadBottomHero } from 'sdk/sections/sdk-download-bottom-hero/SDKDownloadBottomHero'

import { Hero } from './sections/hero/Hero'
import CTA from './sections/CTA/CTA'
import FeaturesSection from './sections/features/FeaturesSection'
import CapabilitiesSection from './sections/capabilities/CapabilitiesSection'
import PerformanceSpecsSection from './sections/performance-specs/PerformanceSpecsSection'
import { SoundcoreTestimonialsSection } from './sections/soundcore-testimonials/SoundcoreTestimonialsSection'

import type { SoundcorePageLoaderData } from './interfaces'

export const SoundcorePage: React.FC = () => {
  const { cmsContent } = useLoaderData() as SoundcorePageLoaderData

  if (!cmsContent) {
    throw new Error('Soundcore CMS content missing')
  }

  return (
    <>
      <Hero content={cmsContent.hero} />
      <Content gap={150}>
        <CTA content={cmsContent.cta} />
        <Divider />
        <FeaturesSection content={cmsContent.features} />
        <FlagshipProduct content={cmsContent.flagshipProduct} />
        <Divider pillText='Coming soon' />
        <PartnerProducts products={cmsContent.partnerProducts} />
      </Content>
      <SoundcoreTestimonialsSection content={cmsContent.testimonials} />
      <Content gap={150}>
        <CapabilitiesSection content={cmsContent.capabilities} />
        <PerformanceSpecsSection content={cmsContent.performanceSpecs} />
      </Content>
      <SDKDownloadBottomHero content={cmsContent.bottomHero} />
    </>
  )
}
